export default __webpack_public_path__ + "static/media/InsideBones_04.95a1f3e2.png";